import { createScreenStyles } from '../../theme/styles';
import React, { useState, useEffect }  from 'react';
import { 
  View, 
  Text, 
  StyleSheet, 
  TextInput,
  TouchableHighlight,
  Dimensions,
  FlatList,
  Platform,
  ActivityIndicator
 } from 'react-native';

import { Entypo } from '@expo/vector-icons';
const screenWidth = Math.round(Dimensions.get('window').width);
const screenHeight = Math.round(Dimensions.get('window').height);

export function isIphoneX() {
  return (
    Platform.OS === 'ios' && screenHeight >= 812
  );
}

export function isAndroid() {
  return (
    Platform.OS !== 'ios'
  );
}

export default function PitStop({ route, navigation }) {

  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [search, setSearch] = useState("");
  const [docs, setDocs] = useState("");

  const { status } = route.params;

  async function loadItens() {
    const response = await fetch(
      'https://superfrio-back-dev.vercel.app/checklistpit/status/' + status
    );

    const data = await response.json();
    setDocs(data.filter(item => 
      item.rsocial && item.rsocial.toLowerCase().includes(search.toLowerCase()) ||
      item.controlid && item.controlid.toLowerCase().includes(search.toLowerCase()) ||
      item.dataentrada && item.dataentrada.toLowerCase().includes(search.toLowerCase())
    ));
    //setDocs(data);
    setLoading(false);
  }
  
  async function loadAllItens() {
    const response = await fetch(
      'https://superfrio-back-dev.vercel.app/checklistpit/status/' + status
    );

    const data = await response.json();
    setDocs(data);
    setLoading(false);
  }

  function emptySearch(){
    if(search != ''){
      setSearch('');
      loadAllItens();
    }
  }

  async function refreshList() {
    setRefreshing(true);
    await loadItens();
    setRefreshing(false);
  }

  useEffect(() => {
    setLoading(true);
    loadAllItens();
  }, []);

  return (

    <View style={styles.container}>
      
      <View style={styles.searchBar}>
        
        <TextInput
               style={styles.textSearch}
               placeholder='Procurar por ID'
               placeholderTextColor="#484848"
               maxLength={20}
               autoCapitalize='none'
               value={search}
               onChangeText={setSearch}
             />
        <Entypo name={'magnifying-glass'} style={styles.searchIconResetFirst} onPress={() => loadItens()} size={24} color="#000" />  
        <Entypo name={'squared-cross'} style={styles.searchIconReset} onPress={() => emptySearch()} size={24} color="#8e1600" />  
      </View>


      <FlatList
        data={docs}
        keyExtractor={docs => String(docs._id)}
        //onEndReached={() => loadPage()}
        //onEndReachedThreshold={0.1}
        onRefresh={refreshList}
        refreshing={refreshing}
        ListEmptyComponent={loading == false &&
          <>
            <Text style={styles.textEmpty}>Não encontramos, tente outra busca !</Text>
          </>

          }
        ListHeaderComponent={
          loading ? (
            <ActivityIndicator size="large" style={styles.LoadingIndicator} />
          ) : (
            ""
          )
        }
        renderItem={({ item }) => (
          <TouchableHighlight underlayColor={"#a5a5a5"} style={styles.highlightRed} onPress={() => { navigation.navigate('ChecklistPitStop', { checkId: item._id }) }}>
            <View style={styles.containerGeral}>
              <View style={styles.txtContainer}>
                <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Controle ID: </Text>{item.controlid}</Text>
                <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Data Entrada: </Text>{item.dataentrada.substring(8,10) + "/" + item.dataentrada.substring(5,7) + "/" + item.dataentrada.substring(0,4)}</Text>
                <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Razão Social: </Text>{item.rsocial}</Text>

                {
                  item.tipo == 0 &&
                  <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Tipo: </Text>Liberação</Text>
                }
                {
                  item.tipo == 1 &&
                  <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Tipo: </Text>Instalação</Text>
                }

                {
                  item.status == 0 &&
                  <Text numberOfLines={1} style={styles.textDescPend}><Text style={styles.textDescBold}>Status: </Text>Pendente</Text>
                }
                {
                  item.status == 1 &&
                  <Text numberOfLines={1} style={styles.textDescAnd}><Text style={styles.textDescBold}>Status: </Text>Processando</Text>
                }
                {
                  item.status == 2 &&
                  <Text numberOfLines={1} style={styles.textDescOk}><Text style={styles.textDescBold}>Status: </Text>Concluído</Text>
                }

                
              </View>
            </View>
          </TouchableHighlight>
        )}            
      />


          
    </View>
  );

}

var styles = createScreenStyles({
  
  container: {
    flex: 1,
    backgroundColor:'#f3f3f3'
  },

  searchBar:{
    flexDirection:'row',
    backgroundColor:'#fff',
    height:50,
    paddingTop:5,
    marginBottom:2,
    borderBottomColor:'#c7cad1',
    borderBottomWidth:1
  },

  searchIcon:{
    marginLeft:10,
  },

  searchIconReset:{
    marginTop:5,
    marginRight:20
  },

  searchIconResetFirst:{
    marginTop:5,
    marginRight:20
  },

  textSearch:{
    marginLeft:30,
    width: '70%'
  },

  textDesc: {
    fontSize: 14,
    paddingTop:5
  },

  textDescBold: {
    fontSize: 14,
    paddingTop:5,
    fontWeight:'bold',
    color:'#000'
  },

  textDescPend: {
    fontSize: 14,
    paddingTop:5,
    fontWeight:'bold',
    color:'#a80101'
  },

  textDescAnd: {
    fontSize: 14,
    paddingTop:5,
    fontWeight:'bold',
    color:'#fa9200'
  },

  textDescOk: {
    fontSize: 14,
    paddingTop:5,
    fontWeight:'bold',
    color:'#4ead31'
  },

  containerGeral:{
    backgroundColor: '#fff',
    width: '100%',
    paddingLeft:10,
    paddingBottom:10,
    borderRadius:3
  },

  txtContainer:{
    marginTop:5,
  },

  highlightRed:{
    marginTop:2,
    borderColor:'#e7e8ea',
    borderWidth:1,
    //borderWidth:1,
    //borderColor:'red'
  },

  highlightGreen:{
    marginTop:2,
    borderColor:'#e7e8ea',
    borderWidth:1,
    //borderWidth:1,
    //borderColor:'green'
  },

  highlightYellow:{
    marginTop:2,
    borderColor:'#e7e8ea',
    borderWidth:1,
   // borderWidth:1,
    //borderColor:'orange'
  }

})